/**
 * PDF Modal System for Product Technical Sheets
 * AcquaClub Theme Enhancement - Optimized Version
 */

// Funzione per aprire il modal PDF
function openPdfModal(modalId, pdfUrl) {
  const modal = document.getElementById(modalId);
  const iframe = document.getElementById(modalId + '-iframe');
  const downloadLink = document.getElementById(modalId + '-download');
  
  if (!modal || !iframe || !pdfUrl) return;
  
  // Mostra il modal
  modal.style.display = 'block';
  document.body.style.overflow = 'hidden';
  
  // Lazy load: Carica il PDF solo quando il modal si apre
  iframe.src = pdfUrl + '#view=FitH&toolbar=1&navpanes=0';
  
  // Imposta il link di download
  if (downloadLink) {
    downloadLink.href = pdfUrl;
  }
  
  // Chiudi con ESC
  const escHandler = function(e) {
    if (e.key === 'Escape') {
      closePdfModal(modalId);
      document.removeEventListener('keydown', escHandler);
    }
  };
  
  document.addEventListener('keydown', escHandler);
}

// Funzione per chiudere il modal PDF
function closePdfModal(modalId) {
  const modal = document.getElementById(modalId);
  const iframe = document.getElementById(modalId + '-iframe');
  
  if (!modal) return;
  
  modal.style.display = 'none';
  document.body.style.overflow = '';
  
  // Pulisci l'iframe per liberare memoria
  if (iframe) {
    iframe.src = '';
  }
}

// Esponi le funzioni globalmente
window.openPdfModal = openPdfModal;
window.closePdfModal = closePdfModal;

// Auto-apri popup quando si clicca sul tab "Scheda Tecnica"
function setupAutoOpenPopup() {
  // Aspetta che il DOM sia caricato
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAutoOpenPopup);
    return;
  }
  
  // Lazy loading: Cerca i tab solo quando servono
  const productTabs = document.querySelectorAll('.tab--product');
  if (productTabs.length === 0) return;
  
  productTabs.forEach(tab => {
    const tabText = tab.textContent.trim().toLowerCase();
    
    // Se il tab contiene "scheda tecnica"
    if (tabText.includes('scheda tecnica')) {
      
      // Aggiungi listener al click
      tab.addEventListener('click', function() {
        
        // Usa MutationObserver invece di setTimeout per performance migliori
        const observer = new MutationObserver((mutations, obs) => {
          // Cerca il tab content con vari possibili selettori
          let tabContent = findActiveTabContent();
          
          if (tabContent) {
            obs.disconnect(); // Ferma l'osservazione
            handlePdfOpen(tabContent);
          }
        });
        
        // Osserva cambiamenti nel DOM per 500ms max
        observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class']
        });
        
        // Fallback: disconnetti dopo 500ms
        setTimeout(() => observer.disconnect(), 500);
        
        // Tentativo immediato (spesso funziona)
        setTimeout(() => {
          const tabContent = findActiveTabContent();
          if (tabContent) {
            observer.disconnect();
            handlePdfOpen(tabContent);
          }
        }, 150);
      });
    }
  });
}

// Funzione helper per trovare il tab content attivo
function findActiveTabContent() {
  let tabContent = document.querySelector('.tab__content--active');
  
  if (!tabContent) {
    tabContent = document.querySelector('.tab__content.active');
  }
  if (!tabContent) {
    tabContent = document.querySelector('.tab-content--active');
  }
  if (!tabContent) {
    tabContent = document.querySelector('.tab-content.active');
  }
  if (!tabContent) {
    // Cerca tutti i tab content visibili (lazy)
    const allTabContents = document.querySelectorAll('[class*="tab"][class*="content"]');
    for (let tc of allTabContents) {
      if (tc.offsetHeight > 0 && tc.offsetWidth > 0) {
        tabContent = tc;
        break;
      }
    }
  }
  
  return tabContent;
}

// Funzione helper per gestire l'apertura del PDF
function handlePdfOpen(tabContent) {
  // Prova a trovare il PDF in diversi modi (lazy)
  const embed = tabContent.querySelector('embed');
  const iframe = tabContent.querySelector('iframe');
  
  let pdfUrl = null;
  
  // Cerca prima nell'embed
  if (embed && embed.src) {
    pdfUrl = embed.src.split('#')[0];
  }
  // Poi nell'iframe
  else if (iframe && iframe.src) {
    pdfUrl = iframe.src.split('#')[0];
  }
  // Cerca anche nei link di download
  else {
    const downloadLink = tabContent.querySelector('a[href*=".pdf"]');
    if (downloadLink) {
      pdfUrl = downloadLink.href.split('?')[0];
    }
  }
  
  const modalId = 'scheda-tecnica-modal';
  
  if (pdfUrl && pdfUrl.includes('.pdf')) {
    openPdfModal(modalId, pdfUrl);
  }
}

// Inizializza al caricamento (lazy)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupAutoOpenPopup);
} else {
  setupAutoOpenPopup();
}

